import React from "react"
import autobind from "class-autobind"
import AppStateStore from "../../../stores/AppStateStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import { ISelectedFilterTemplateId, EDefaultFilterValues, ITimeoffFilter } from "../../../models"
import FilterTemplate from "../FilterTemplate"
import AddTimeoffFilterTemplateDialogContainer from "./AddTimeoffFilterTemplateDialogContainer"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import * as utils from "../../../helpers/utils"

interface IProps {
    filterTemplates: ITimeoffFilter[]
    selectedFilterTemplateId: ISelectedFilterTemplateId
    handleChangeFilterTemplates(filterTemplates: ITimeoffFilter[]): void
    handleSelectFilterTemlate(selectedFilterTemplateId: ISelectedFilterTemplateId): void
}
interface IState {
}

export default class TimeoffFilter extends React.Component<IProps, IState> {
    private AddTimeoffFilterTemplateDialogContainer
    constructor(props: IProps) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    async handleAddFilter(name: string) {
        const filter: ITimeoffFilter = this.AddTimeoffFilterTemplateDialogContainer.state.filterData
        filter.Id = utils.guid()
        filter.Name = name
        this.props.handleChangeFilterTemplates([...this.props.filterTemplates, filter])
        AppStateStore.setProgressSnackbarContent("loading")
        await api.addTimeoffFilter(AuthenticationStore.getLoggedInUser().Id, filter)
        this.props.handleSelectFilterTemlate(filter.Id)
        AppStateStore.setProgressSnackbarContent(strings.Filter_Saved)
    }

    async handleUpdateFilter(name: string) {
        const filter: ITimeoffFilter = this.AddTimeoffFilterTemplateDialogContainer.state.filterData
        filter.Name = name
        this.props.handleChangeFilterTemplates(this.props.filterTemplates.map(i => i.Id === filter.Id ? filter : i))
        AppStateStore.setProgressSnackbarContent("loading")
        await api.updateTimeoffFilter(AuthenticationStore.getLoggedInUser().Id, filter)
        this.props.handleSelectFilterTemlate(filter.Id)
        AppStateStore.setProgressSnackbarContent(strings.Filter_Updated)
    }

    async handleDeleteFilter(filterId: string) {
        this.props.handleChangeFilterTemplates(this.props.filterTemplates.filter(i => i.Id !== filterId))
        AppStateStore.setProgressSnackbarContent("loading")
        await api.deleteTimeoffFilter(AuthenticationStore.getLoggedInUser().Id, filterId)
        this.props.handleSelectFilterTemlate(EDefaultFilterValues.NONE)
        AppStateStore.setProgressSnackbarContent(strings.Filter_Deleted)
    }

    render() {
        const editFilterTemplate = (this.props.selectedFilterTemplateId === EDefaultFilterValues.CREATE_NEW || this.props.selectedFilterTemplateId === EDefaultFilterValues.NONE) ?
            null : this.props.filterTemplates.find(i => i.Id === this.props.selectedFilterTemplateId)
        return (
            <FilterTemplate
                addFilterTemplateLabel={strings.Create_New_Timeoff_Filter}
                editFilterTemplateLabel={strings.Edit_Timeoff_Filter}
                filterTemplates={this.props.filterTemplates}
                selectedFilterTemplateId={this.props.selectedFilterTemplateId}
                style={{ marginTop: -15, marginLeft: 25 }}
                handleSelectFilterTemlate={this.props.handleSelectFilterTemlate}
                handleSave={name => editFilterTemplate ? this.handleUpdateFilter(name) : this.handleAddFilter(name)}
                handleDeleteFilterTemplate={this.handleDeleteFilter}
            >
                <AddTimeoffFilterTemplateDialogContainer
                    ref={item => this.AddTimeoffFilterTemplateDialogContainer = item}
                    editFilterTemplate={editFilterTemplate}
                />
            </FilterTemplate>
        )
    }
}
